/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const footerLandingConfig = {
  footerBrandLogo: 'https://klefki.io/static/media/klefki-2.64f4edc8.png',
  footerBrandTitle: '',
  footerBrandLink: 'https://trag-vlinder.io/',
  footerBrandTitleStyle: {
    fontFamily: 'muli',
  },
  footerBrandDescription: 'Seamless, Near Real-Time Experience for Customers',
  footerUsefulLinkLabel: 'Company',
  footerUsefulLinks: [
    {
      name: 'About us',
      link: 'https://trag-vlinder.io/',
    },
    {
      name: 'Contact us',
      link: 'https://trag-vlinder.io/#contact',
    },
  ],
  footerServiceLinkLabel: 'Other Links',
  footerServiceLinks: [
    {
      name: 'Privacy Policy',
      link: '/privacy',
      target: '_blank',
    },
    {
      name: 'Terms and Condition',
      link: '/terms',
      target: '_blank',
    },
  ],
  footerContactLabel: 'Need Help ? ',
  footerContactLinks: [
    {
      name: 'Email:',
      value: 'info@vlinder.io',
    },
    {
      name: 'Phone:',
      value: '+91 80 4155 7384',
    },
  ],
  footerCopyright: {
    brandTitle: 'vlinder',
    target: '_blank',
    copyrightTitle: 'vlinder',
    startYear: '2018',
  },
  socialLinks: [
    {
      name: 'facebook',
      link: 'https://www.facebook.com/vlinder.labs.56',
    },
    {
      name: 'twitter',
      link: 'https://twitter.com/govlinder?lang=en',
    },
    {
      name: 'instagram',
      link: 'https://www.instagram.com/vlinder.io/?hl=en',
    },
    {
      name: 'linkedin',
      link: 'https://www.linkedin.com/company/vlinder-io?originalSubdomain=in',
    },
  ],
};
